import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/cm/guideline-documents', { params });
  },
  detail(id) {
    return axios.get(`/v1/cm/guideline-documents/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/cm/guideline-documents/${id}`, params);
  },
  create(data) {
    return axios.post('/v1/cm/guideline-documents', data);
  },
  delete(id) {
    return axios.delete(`/v1/cm/guideline-documents/${id}`);
  }
};
